import * as React from 'react';

const SvgIconFineDiner = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={26} height={24} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M4.75 12.75h16.5v8a1 1 0 01-1 1H5.75a1 1 0 01-1-1v-8z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 13.447a6 6 0 013-11.2c4.5 0 5.25 4.5 9 4.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.25 13.447a6 6 0 00-3-11.2c-2.54 0-3.885 1.434-5.25 2.683M9.25 17.25v1.5M13 17.25v1.5M16.75 17.25v1.5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconFineDiner;
